module.exports = __webpack_public_path__ + "img/ogp.4fa13e2.png";